// @flow

import { trackLink, trackImpression } from 'lib/analytics/fpti'

export const UNILATERAL_RECIPIENT_CHOICE_PAGE_GROUP =
  'main:p2p:unilateralRecipientChoice'
export const UNILATERAL_RECIPIENT_CHOICE_PAGE_NAME =
  'main:p2p:unilateralRecipientChoice::'

/**
 * Track unilateral recipient choice overpanel impression via FPTI analytics
 */
export function trackUnilateralRecipientChoiceImpression() {
  trackImpression(
    UNILATERAL_RECIPIENT_CHOICE_PAGE_GROUP,
    UNILATERAL_RECIPIENT_CHOICE_PAGE_NAME
  )
}

/**
 * Track unilateral recipient choice cancel button click on overpanel via FPTI analytics
 */
export function trackUnilateralRecipientChoiceCancel() {
  trackLink(
    'cancel',
    UNILATERAL_RECIPIENT_CHOICE_PAGE_GROUP,
    UNILATERAL_RECIPIENT_CHOICE_PAGE_NAME,
    'link',
    {}
  )
}

/**
 * Track unilateral recipient choice primary submit button via FPTI analytics
 */
export function trackUnilateralRecipientChoiceSubmit() {
  trackLink(
    'submit',
    UNILATERAL_RECIPIENT_CHOICE_PAGE_GROUP,
    UNILATERAL_RECIPIENT_CHOICE_PAGE_NAME,
    'link',
    {}
  )
}
